// ─────────────────────────────────────────────────────────────
//  HEROESBEND HOTEL — Brand & contact constants
//  Replace the placeholder phone numbers, address and bank
//  details below with the hotel's real information.
// ─────────────────────────────────────────────────────────────

export const BRAND = {
  name: 'Heroesbend Hotel',
  legal: 'Heroesbend Hotel Ltd',
  tagline: 'Riverside luxury on Lagos Marina',
  website: 'heroesbend.com',
  websiteUrl: 'https://heroesbend.com',
  email: 'reservations@heroesbend.com',
  logo: '/images/hb/logo.png',

  // Address
  addressShort: 'Jacob Zuma Road, Owerri, Imo',
  addressLines: [
    ' 27 Jacob Zuma/Athan Ogu Street',
    'Owerri',
    'Imo State, Nigeria',
  ],
  city: 'Imo',
  region: 'Imo State',

  // Phones — { tel: E.164 for links, label: display }
  phones: [
    { tel: '+2349138927291', label: '0913 892 7291' },
    { tel: '+2349138927291', label: '0913 892 7291' },
  ],
  whatsapp: '+2349138927291',
  whatsappLabel: '0913 892 7291',

  // Bank transfer details (used at checkout)
  bank: {
    account: '5620166586',
    bank: 'Fidelity Bank Plc (Fidelity)',
    name: 'HÉROES BEND HOTELS',
    email: 'reservations@heroesbend.com',
  },
};

export const whatsappLink = (num = BRAND.whatsapp) =>
  `https://wa.me/${num.replace('+', '')}`;

export default BRAND;
